export default __webpack_public_path__ + "static/media/image-real-deal.036b9d80.jpg";